<h1 class="h5">Offers</h1>
<div class="card card-body border-0 shadow">
  <button class="btn btn-primary w-100 fw-bold d-block d-lg-none mb-2" type="button" data-bs-toggle="collapse"
          data-bs-target="#filters" aria-expanded="false" aria-controls="filters"><i class="bi bi-funnel"></i> Filters
  </button>

  <form [formGroup]="filters" id="filters" class="collapse filters">
    <div class="row mb-3 g-2">
      <div class="col-lg-2">
        <input formControlName="name" type="text" class="form-control form-control-sm"
               placeholder="Search for offers...">
      </div>

      <div class="col-lg-2">
        <select formControlName="conversionType" class="form-select form-select-sm">
          <option value="">All Payout Type</option>
          <option *ngFor="let conversionType of conversionTypeList"
                  [value]="conversionType">{{ ('conversionType.' + conversionType) | translate }}
          </option>
        </select>
      </div>

      <div class="col-lg">
        <div class="d-flex">
          <app-dropdown-select placeholder="All verticals" formControlName="verticals" [multiple]="true" class="w-100">
            <app-dropdown-select-option *ngFor="let vertical of verticalList" [value]="vertical.id">
              {{ ('vertical.' + vertical.identifier) | translate }}
            </app-dropdown-select-option>
          </app-dropdown-select>
        </div>
      </div>

      <div class="col-lg-2">
        <select formControlName="requireApproval" class="form-select form-select-sm">
          <option value="">All Statuses</option>
          <option [value]="false">Public</option>
          <option [value]="true">Apply to run</option>
        </select>
      </div>

      <div class="col-lg">
        <div class="d-flex">
          <app-dropdown-select placeholder="🌍 All countries" formControlName="countries" [multiple]="true"
                               class="w-100">
            <app-dropdown-select-option *ngFor="let country of countries" [value]="country.isoCode">
              {{ country.flagEmoji }} {{ country }}
            </app-dropdown-select-option>
          </app-dropdown-select>
        </div>
      </div>

      <div class="col-lg-auto">
        <button (click)="fetchAll()" type="submit" class="btn btn-primary btn-sm fw-bold">Submit</button>
      </div>
    </div>
  </form>

  <div class="table-responsive">
    <table class="table table-hover table-striped">
      <thead class="table-light">
      <tr>
        <th width="67">Image</th>
        <th>Offer Name</th>
        <th>Geos</th>
        <th width="96">Payout Type</th>
        <th>Payout</th>
        <th width="117">Approval</th>
        <th>Vertical</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let offer of offers; let i = index">
        <td class="align-middle">
          <a [routerLink]="['/offer', offer.id]">
            <img *ngIf="offer.product?.logo" [src]="imageService.getImageUrl(offer.product?.logo, 50, 50, false)"
                 class="offers-image" alt="Logo"/>
          </a>
        </td>
        <td class="align-middle"><a [routerLink]="['/offer', offer.id]">{{ offer }}</a></td>
        <td class="align-middle">
          <ng-container *ngIf="!expandedCountries[i]">
            <span *ngFor="let country of offer.countries.slice(0, 5)">
              {{ offer.getCountryEmoji(country) }}
            </span>
            <span *ngIf="offer.countries.length > 5" class="text-muted" role="button"
                  (click)="expandedCountries[i] = true">...({{ offer.countries.length }})</span>
          </ng-container>

          <ng-container *ngIf="expandedCountries[i]">
            <span *ngFor="let country of offer.countries">
              {{ offer.getCountryEmoji(country) }}
            </span>
            <i (click)="expandedCountries[i] = false" class="bi bi-eye-slash-fill ms-1 text-muted" role="button"></i>
          </ng-container>
        </td>
        <td class="align-middle">{{ ('conversionType.' + offer.conversionType) | translate }}</td>
        <td class="align-middle">{{ offer.getRegistrationPayout() | currency: 2:offer.currency?.isoCode }}</td>
        <td class="align-middle">
          <span [ngClass]="getOfferStatusClass(offer)"
                class="badge">{{ ('partnerOfferStatus.' + getOfferStatus(offer)) | translate }}</span>
        </td>
        <td class="align-middle">
          <ng-container *ngIf="offer?.verticals">
            <ng-container *ngFor="let vertical of offer?.verticals; let last = last">
              {{ getVerticalName(vertical) | translate }}
              <ng-container *ngIf="!last"> /</ng-container>
            </ng-container>
          </ng-container>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <app-paginator (pageChange)="fetchAll()" [paginator]="paginator"></app-paginator>
</div>
